export default "__VITE_ASSET__KdLWITFP__"